import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { canModifyEmployeeByRoleName } from '../../permissions/roleUtils';
import { useRoles } from '../../hooks/useRoles';

function EmployeeDeactivateCell({ cellValues, onDeactivate }) {
    const authenticated = useSelector((state) => state.UserReducer.isAuthenticated);
    const { data: allRoles = [] } = useRoles();
    const canModify = canModifyEmployeeByRoleName(authenticated, allRoles, cellValues.row.userRole);

    if (!canModify) {
        return null;
    }

    if (cellValues.row.deleted === null) {
        return (
            <Button variant="contained" color="error" onClick={() => onDeactivate(cellValues)}>
                Deactivate
            </Button>
        );
    }

    return (
        <Button variant="contained" color="secondary" onClick={() => onDeactivate(cellValues)}>
            Reactivate
        </Button>
    );
}

export default EmployeeDeactivateCell;
